if (!window.nsMegaMenuReady) {
  window.nsMegaMenuReady = true;
  const closeMenus = (except = null) => {
    document.querySelectorAll('.ns-mega-header .header__menu-disclosure[open]').forEach(details => {
      if (details === except || details.contains(except)) return;
      const control = details.parentElement;
      if (typeof control.close === 'function') control.close();
      details.setAttribute('aria-expanded', 'false');
      details.removeAttribute('open');
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.ns-mega-header mega-menu-disclosure>details[open]');
    if (open) {
      closeMenus();
      open.querySelector('summary').focus();
    }
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.ns-mega-header')) closeMenus();
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.ns-mega-header')) closeMenus();
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.ns-mega-header mega-menu-disclosure>details') && event.target.open) closeMenus(event.target);
  }, true);
}
